export default __webpack_public_path__ + "static/media/WIN_WHITE.702941e0.png";